import styles from "./Row.module.sass";
import cn from "classnames";
import moment from "moment";
import { useNavigate } from "react-router";

const Row = ({ item, activeTable, activeId, setActiveId }) => {
  const navigate = useNavigate();

  const handleUpdate = (role) => {
    if (!role || !role.id) {
      console.error("Invalid role data:", role);
      return;
    }
    setActiveId(role.id);
    
    if (role.type === "MASTER") {
      navigate(`/settingsDashboard/accessControl/roles/${role.id}`);
    } else {
      navigate(`/settingsDashboard/accessControl/roles/update/${role.id}`);
    }
  };

  return (
    <div
      className={cn(
        styles.row,
        { [styles.selected]: activeId === item?.id },
        { [styles.active]: activeTable }
      )}
      onClick={() => handleUpdate(item)}
    >
      <div className={styles.col}>
        <div className={styles.email}>{item?.role}</div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>
          {item?.type === "CUSTOM" ? item?.creator?.full_name : "Default"}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>
          {item?.created_at ? moment(item.created_at).format("DD MMM YYYY") : "N/A"}
        </div>
      </div>
      <div className={styles.col}>
        <div
          className={cn(styles.purchase, {
            "status-role-active": item?.status === true,
            "status-role-inactive": item?.status === false,
          })}
        >
          {item?.status ? "Active" : "Inactive"}
        </div>
      </div>
    </div>
  );
};

export default Row;